export const drawerWidth = 200;
export const secondaryPanelWidth = 400;
